import { cn } from "@workspace/frontend-ui";

export default cn;
